import { useLang } from "@/i18n/LanguageContext";
import { useContent } from "@/lib/hooks";
import PageHeader from "@/components/PageHeader";
import { ServiceIcon } from "@/components/ServiceIcon";

export default function Services() {
  const { t, ml } = useLang();
  const { data: services = [], isLoading } = useContent("/content/services");

  return (
    <div data-testid="services-page">
      <PageHeader title={t("services.title")} subtitle={t("services.subtitle")} testId="services-title" />
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        {isLoading ? (
          <p className="text-zinc-500">{t("common.loading")}</p>
        ) : (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="services-grid">
            {services.map((service) => (
              <div
                key={service.id}
                className="group rounded-2xl border border-zinc-200 bg-white p-8 transition-all duration-300 hover:border-[#1A4BFF] hover:shadow-[0_12px_40px_-16px_rgba(26,75,255,0.35)]"
              >
                <span className="flex h-14 w-14 items-center justify-center rounded-xl bg-[#EEF2FF] text-[#1A4BFF] transition-colors duration-300 group-hover:bg-[#1A4BFF] group-hover:text-white">
                  <ServiceIcon name={service.icon} className="h-7 w-7" />
                </span>
                <h3 className="mt-6 font-heading text-xl font-bold text-zinc-950">{ml(service.title)}</h3>
                <p className="mt-3 text-sm leading-relaxed text-zinc-600">{ml(service.description)}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
